export default function ManifestoSection() {
  return (
    <section className="py-32 px-6 bg-background border-y border-border reveal">
      <div className="max-w-4xl mx-auto text-center space-y-12">
        <p className="text-3xl md:text-4xl text-foreground leading-relaxed max-w-3xl mx-auto">
          One product. One release. 1,000 units. No restocks.
        </p>

        <div className="h-px w-24 mx-auto bg-border"></div>

        <div className="space-y-8">
          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            Most rooms are lit. Few are felt.
          </p>

          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            IGNISS // 001 was created to change how a space feels, not how it looks on a shelf.
          </p>

          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            Flame-inspired light. Gentle ultrasonic mist. Silent operation.
          </p>

          <p className="text-xl md:text-2xl text-foreground leading-relaxed max-w-2xl mx-auto">
            Designed to slow the room down.
          </p>
        </div>
      </div>
    </section>
  )
}